import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import LandingPage from "@/pages/LandingPage";

export function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const { pathname } = useLocation();

  if (loading) {
    return (
      <div className="flex h-screen items-center justify-center bg-background text-sm text-muted-foreground" data-testid="auth-loading">
        Loading…
      </div>
    );
  }

  if (!user) {
    // Show the marketing landing page at root; redirect to login everywhere else
    if (pathname === "/") return <LandingPage />;
    return <Navigate to="/login" replace />;
  }

  return children;
}
